import React, { useEffect, useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';

//import images
import avatar1 from "../../assets/images/users/avatar-1.jpg";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const ProfileDropdown = (props: any) => {
    const { currentUser } = props;

    const navigate = useNavigate();

    useEffect(() => {
        if (currentUser === null || currentUser?.data === null) {
            toast.error("Uh-oh! It seems you don't have permission to access the app at the moment. Please get in touch with the admin for assistance. Thank you!")
            localStorage.clear()
            navigate("/login");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentUser])

    const handleLogout = () => {
        localStorage.clear()
        navigate('/login')
    }

    //Dropdown Toggle
    const [isProfileDropdown, setIsProfileDropdown] = useState(false);
    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };
    return (
        <React.Fragment>
            <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown} className="ms-sm-3 header-item topbar-user">
                <DropdownToggle tag="button" type="button" className="btn">
                    <span className="d-flex align-items-center">
                        <img className="rounded-circle header-profile-user" src={avatar1}
                            alt="Header Avatar" />
                    </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                    <h6 className="dropdown-header">Welcome {currentUser?.firstName}!</h6>
                    <DropdownItem className='p-0'>
                        <div className="dropdown-item">
                            <i className="mdi mdi-account text-muted fs-16 align-middle me-1"></i>
                             <span className="align-middle" data-key="t-logout">Profile</span>
                        </div>
                    </DropdownItem>
                    <DropdownItem className='p-0'>
                        <div className="dropdown-item">
                            <i className="mdi mdi-cog text-muted fs-16 align-middle me-1" aria-hidden="true"></i>
                            <span className="align-middle" data-key="t-logout">Setting</span>
                        </div>
                    </DropdownItem>
                    <DropdownItem className='p-0'>
                        <div onClick={handleLogout} className="dropdown-item">
                            <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> 
                            <span className="align-middle" data-key="t-logout">Logout</span>
                        </div>
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default ProfileDropdown;